import React, { useState } from 'react'
import { postSuministrosEnUnPaquete } from '../../../services/PaginaRuta'
import ModalSuministroRepetidos from './ModalSuministroRepetidos'
import ModalSuministrosConfirmarCantidad from './ModalSuministrosConfirmarCantidad'

const TablaListaDeSuministros = ({item,idCirugia, passINfodata}) => {
  //const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
  const [modalOnSuministrosConfirmarCantidad, setmodalOnSuministrosConfirmarCantidad]=useState(false)
  const [modalOnSuministrosRepetidos, setmodalOnSuministrosRepetidos]=useState(false)
  const handleOnclickSuministro=()=>{
    setmodalOnSuministrosConfirmarCantidad(true)
    //clinica cartagena
    // const paqueteGenericoCodigo = '39'
        

    //produccion pruebas 
    // const paqueteGenericoCodigo = '94'

    //clinica estancia
    // const paqueteGenericoCodigo = 'GER'

    //variable de entorno
  //   const paqueteGenericoCodigo = process.env.REACT_APP_PAQUETE_GENERICO_ID
    
  //   const body={
  //     varProEmpCod:usuarioInfo.Empresa,
  //     varProMCDpto:usuarioInfo.Sede,
  //     varProCirCod: idCirugia,
  //     varPaqCod: paqueteGenericoCodigo,
  //     varProCirCod: idCirugia,
  //     varPaqCod:paqueteGenericoCodigo,
  // }
  // postSuministrosEnUnPaquete(body).then((res)=>{
  //   let dataSuministros = []
  //   dataSuministros = res.data
    // let buscarSuministrosRepetidos = dataSuministros.some((repetido)=>repetido.MSNomG == item.MSNomG)
    // if(buscarSuministrosRepetidos){
    //   //console.log('repetido')
    //   setmodalOnSuministrosRepetidos(true)
    // }else{
      //console.log('no repetido')
      //setmodalOnSuministrosConfirmarCantidad(true)
    //}
  //})
  // if(parseInt(item.PaqCod) == 94){}
  //   setmodalOnSuministrosConfirmarCantidad(true)
  }
  return (
    <>
      <tr className="border-b">
        <td className="text-xs font-medium py-2 whitespace-pre-wrap"><button
                type="button"
                onClick={handleOnclickSuministro}
                className="inline-block px-3 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
              >
                Agregar
              </button></td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap">{item.MSRESO}</td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap text-left">{item.MSNomG}</td> 
        <td className="text-xs font-medium py-2 whitespace-pre-wrap text-left">{item.CncDes}</td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap text-left">{item.FSmDscUMd}</td>
        <td className="text-xs font-medium py-2 whitespace-pre-wrap text-left">{item.MarDsc}</td>     
      </tr>
      {modalOnSuministrosConfirmarCantidad? <ModalSuministrosConfirmarCantidad item={item} setmodalOnSuministrosConfirmarCantidad={setmodalOnSuministrosConfirmarCantidad} idCirugia={idCirugia} passINfodata={passINfodata}/>: null}
      {modalOnSuministrosRepetidos? <ModalSuministroRepetidos setmodalOnSuministrosRepetidos={setmodalOnSuministrosRepetidos}/>:null}
    </>
  )
}

export default TablaListaDeSuministros